import { render, staticRenderFns } from "./userChart.vue?vue&type=template&id=4356c1cf&scoped=true"
import script from "./userChart.vue?vue&type=script&lang=js"
export * from "./userChart.vue?vue&type=script&lang=js"
import style0 from "./userChart.vue?vue&type=style&index=0&id=4356c1cf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356c1cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4356c1cf')) {
      api.createRecord('4356c1cf', component.options)
    } else {
      api.reload('4356c1cf', component.options)
    }
    module.hot.accept("./userChart.vue?vue&type=template&id=4356c1cf&scoped=true", function () {
      api.rerender('4356c1cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/userChart.vue"
export default component.exports